import { render, staticRenderFns } from "./discountsHistory.vue?vue&type=template&id=d757f29a"
import script from "./discountsHistory.vue?vue&type=script&lang=js"
export * from "./discountsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports